import { ScanLine, Ruler, Smartphone, FileCheck2 } from 'lucide-react';
import { SectionHeading } from '@/components/home/SectionHeading';
import { HOME } from '@/constants/testIds';

const REASONS = [
  { Icon: ScanLine, title: 'Sudut yang anda perlukan', desc: 'Pintu masuk, porch dan laluan belakang disemak. Bilangan kamera ikut layout rumah.' },
  { Icon: Ruler, title: 'Pemasangan yang kemas', desc: 'Laluan Cat6 concealed atau trunking dipersetujui mengikut keadaan rumah.' },
  { Icon: Smartphone, title: 'Telefon siap disambung', desc: 'Kami setup Hik-Connect dan tunjuk cara guna live view serta playback.' },
  { Icon: FileCheck2, title: 'Waranti bertulis', desc: 'Workmanship 12 bulan. Model, skop dan terma disenaraikan dalam quotation.' },
];

export const WhyUs = () => (
  <section id="kenapa" data-testid={HOME.whyUsSection} className="gg-section gg-why">
    <div className="gg-container">
      <SectionHeading id="why-us" eyebrow="BUKAN SEKADAR PASANG KAMERA" title="Dirancang betul. Dipasang kemas. Siap digunakan." />
      <div className="gg-reasons-grid">{REASONS.map(({ Icon, title, desc }, i) => <div key={title} className="gg-reason" data-testid={`why-us-reason-${i}`}><Icon size={25} /><h3>{title}</h3><p>{desc}</p></div>)}</div>
    </div>
  </section>
);

export default WhyUs;